/**
 * Sameday's iOS App Store listing.
 *
 * Shared because more than one surface links to it (the phone settings
 * download row, the minimum-build update gate) and the listing id is not
 * something to re-type per call site.
 *
 * Kept as an `https://apps.apple.com/...` URL rather than `itms-apps://`: iOS
 * claims that domain as a universal link, so the shell's
 * `UIApplication.open` hands it straight to the App Store app, while any
 * non-iOS context still resolves to a real page.
 */
export const IOS_APP_STORE_URL =
  "https://apps.apple.com/us/app/sameday-ai/id6793232401";
